import { LiveAnnouncer } from '@angular/cdk/a11y';
import { Component, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { Router } from '@angular/router';

import { PaginationInstance } from 'ngx-pagination';
import { NgxPermissionsService } from 'ngx-permissions';
import { NgxSpinnerService } from 'ngx-spinner';
import { AddImportantNoticeComponent } from 'src/app/pages/add-important-notice/add-important-notice.component';
import { DeleteItemComponent } from 'src/app/pages/delete-item/delete-item.component';
import { Filter } from 'src/app/pages/filter/filter.model';
import { ViewImportantNoticeComponent } from 'src/app/pages/important-notice/view-important-notice/view-important-notice/view-important-notice.component';
import { RecConfirmModalComponent } from 'src/app/pages/recruitment/rec-confirm-modal/rec-confirm-modal.component';
import { AppService } from 'src/app/services/app/app.service';
import { CommonService } from 'src/app/services/common/common.service';
import { CompanyService } from 'src/app/services/company/company.service';
import { GlobalService } from 'src/app/services/global/global.service';
import { JobService } from 'src/app/services/job/job.service';

@Component({
  selector: 'app-job-request',
  templateUrl: './job-request.component.html',
  styleUrls: ['./job-request.component.scss']
})
export class JobRequestComponent {
  public displayedColumns: string[] = ['date','employee','category','time','location','status','action'];
  public dataSource = new MatTableDataSource();
  public count!: any;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  public isFilterShow: boolean = false;
  pageIndex = 0;
  pageSize = 15;
  public isSpinnerLoading: boolean = false;
  private animationConfig: {} = { enterAnimationDuration: '300ms', exitAnimationDuration: "300ms" }
  
  public pageSizeOptions = GlobalService.pageSizeOptions;
  public maxPaginationSize = GlobalService.maxPaginationSize
  public config: PaginationInstance = {
    itemsPerPage: this.pageSizeOptions[0],
    currentPage: 0,
  };
  public filterObj: Filter = {
    operand: "or",
    arr: []
  }
  public filterArr: any[] = [
    { key_name: "Title", key_val: "tit", type: 'text' },
    { key_name: "Category", key_val: "d_i", type: 'select' },
    { key_name: "Location", key_val: "d_i", type: 'select' },
    { key_name: "Start Date", key_val: "st_dt", type: 'date' },
    { key_name: "End Date", key_val: "ed_dt", type: 'date' },
  ]
  public currentTab:string='open_shift';
  public searchInput: string = '';
  private previousInputValue: string = '';
  public userType!:string;
  constructor( public dialog: MatDialog, private router: Router, 
    private spinner: NgxSpinnerService, private appService: AppService,
    private commonService: CommonService,private jobService:JobService) { }

  ngOnInit(): void {

    const userInfo = JSON.parse(this.appService.getData('training-portal.userInfo'));
    // this.userType = userInfo.u_typ == 0 ? 'company' : 'recruiter';
    this.userType = userInfo.u_typ == 0 ? 'company' : (userInfo.u_typ == 1 ? 'recruiter' : 'admin');

    if(this.userType=='recruiter'){
      this.displayedColumns=['date','company','employee','category','time','location','status','action']
    }
    else{
      this.displayedColumns=['date','employee','category','time','location','status','action']
    }
    this.commonService.setTitle("Requests")
    this.onPageChange(1)
  }
  onBack(){
    this.router.navigate(['/rec/job-cal'])
  }
  onPageSizeChange(event: Event) {
    const tar = event.target as HTMLInputElement
    this.config.itemsPerPage = Number(tar.value)
    this.config.currentPage = 1
    this.list()
  }
  onPageChange(number: number) {
    this.config.currentPage = number;
    this.list()
  }
  onFilterView() {
    this.isFilterShow = !this.isFilterShow;
    if (!this.isFilterShow && this.filterObj.arr.length > 0) {
      this.filterObj.arr = [];
      this.list();
    }
    // if (this.isFilterShow == true) { this.filterArr = [{ filter_value: '', contains: '', containsArr: [''] }] }
  }
  onAddNewNotice() {
    const dialogRef = this.dialog.open(AddImportantNoticeComponent, {
      // data: { data: value, user_type: usertype },
      width: '70%', minWidth: '300px', maxWidth:'750px',height: '98%',maxHeight:'680px', enterAnimationDuration: '300ms', exitAnimationDuration: "300ms",
      // minHeight:'200px'
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        if (result["data_added"] == true) {
          this.list()
        }
      }
    });
  }
  onEditItem(usertype: String, value: any) {
    const dialogRef = this.dialog.open(AddImportantNoticeComponent, {
      data: { data: value, user_type: usertype },
      width: '50%', minWidth: '280px', maxWidth: '771px', height: 'auto', maxHeight: '90vh',
       enterAnimationDuration: '300ms', exitAnimationDuration: "300ms", panelClass: "hire"
      // minHeight:'200px'
    });
    dialogRef.afterClosed().subscribe(result => {

    });
  }
  callApi(obj) {
    this.filterObj = obj
    this.list()
  }
  list() {
    // this.spinner.show();
    this.isSpinnerLoading = true;
    let obj = {
      sh: this.searchInput.trim(),
      st: this.appService.startPageLogic(this.config.currentPage, this.config.itemsPerPage),
      r_p: this.config.itemsPerPage,
      f_a: this.filterObj.arr,
      op_nd: this.filterObj.operand
    }
    this.jobService.jobRequest(obj).subscribe({
      next: (success: any) => {
        // this.spinner.hide();
        this.isSpinnerLoading = false
        if (success.status == 200) {
          this.previousInputValue = this.searchInput;
          this.count = success.count
      
          this.dataSource = new MatTableDataSource(success.msg)
          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort;
        }
      },
      error: (error: any) => {
        this.isSpinnerLoading = false
        this.commonService.handleError(error)
      }})
  }
  onDeleteItem(id: any) {
    const dialogRef = this.dialog.open(DeleteItemComponent, Object.assign({
      data: { api_type: "delete_content", content_type: "delete_notice", id: id }
    }, this.animationConfig));
    dialogRef.afterClosed().subscribe(result => {
      if (result && (result["delete_content"] == true)) {
        this.list()
      }
    });
  }
  doFilter = (event: any) => {
    let newVal = event.target?.value
    this.dataSource.filter = newVal.trim().toLocaleLowerCase()
  }
  onPageEvent = (event: any) => {
    this.pageIndex = event.pageIndex;
    this.pageSize = event.pageSize;
    let startPage = (event.pageIndex) * (event.pageSize) + 1;
  }
  onSearch(event: any) {
    const inputValue = (event.target as HTMLInputElement).value;
    if (inputValue == '' && this.previousInputValue !== '') {
      this.config.currentPage=0
      this.list()
    }
  }
  onGo(){
    if(this.searchInput.trim()!=''){
      this.config.currentPage=0
      this.list()
    }
  }
  onViewNotice(data){    
    const dialogRef = this.dialog.open(ViewImportantNoticeComponent, Object.assign({
      data: data,
      width: '70%', minWidth: '300px', maxWidth:'750px',height: '98%',maxHeight:'680px', 
      enterAnimationDuration: '300ms', exitAnimationDuration: "300ms",
    }, ));
    dialogRef.afterClosed().subscribe(result => {
    });
  }
  onTabChange(value){
    this.currentTab=value;
  }
  onConfirmationModal(element, type) {
    if (element.app == type) { return }
    let data = {
      type: "shift_request",
      text: "status",
      reqObj: {
        app: type, //1 : accep, 0:reject
        em_i: element.em_i,
        j_id: element.id,
      },
      data_type: "change"
    }
    const dialogRef = this.dialog.open(RecConfirmModalComponent, {
      enterAnimationDuration: '300ms', exitAnimationDuration: "300ms", data: data,
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result && result["confirm"] == 'yes') {
        this.list()
      }
    });
  }
}